import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../assets/css/gamesCss/Array/intro1D.css"
import GameOverModal from "../../../components/GameOverModal";
import GameWonModal from "../../../components/GameWonModal";
import { useDarkMode } from "../../../context/DarkModeProvider";
import { useLanguage } from "context/LanguageProvider";
import { Button } from "reactstrap";

const Intro1D = () => {

    const selectedStage = JSON.parse(localStorage.getItem("selectedStage"));
    const { selLanguage, toggleLanguage, isLoading } = useLanguage();
    var games = selectedStage.games;
    var nameGameKey = localStorage.getItem("gameClicked");
    var selectedGame = null;
    for (let i = 0; i < games.length; i++) {
        if (games[i].game_title === nameGameKey) {
            selectedGame = games[i];
            break;
        }
    }

    const [lives, setLives] = useState(3);
    const [score, setScore] = useState(0);
    const [gameState, setGameState] = useState("playing");
    const [selectedLeft, setSelectedLeft] = useState(null);
    const [selectedRight, setSelectedRight] = useState(null);
    const [matchedPairs, setMatchedPairs] = useState([]);
    const [wrongMatches, setWrongMatches] = useState([]);
    const [message, setMessage] = useState("");
    const [showGameOver, setShowGameOver] = useState(false);
    const [showGameWon, setShowGameWon] = useState(false);

    const { darkMode } = useDarkMode();

    const mission = selLanguage ? "Αντιστοίχισε τις έννοιες με τους ορισμούς τους." : "Match the concepts with their definitions."

    const gameData = [
        {
            id: 1,
            concept: selLanguage ? "Ομοιογένεια" : "Homogeneity",
            definition: selLanguage
                ? "Όλα τα στοιχεία του πίνακα έχουν τον ίδιο τύπο δεδομένων."
                : "All elements in the array have the same data type."
        },
        {
            id: 2,
            concept: selLanguage ? "Διατεταγμένη δομή" : "Ordered Structure",
            definition: selLanguage
                ? "Η σειρά των στοιχείων έχει σημασία και κάθε στοιχείο έχει μοναδικό δείκτη πρόσβασης."
                : "The order of elements matters and each element has a unique access index."
        },
        {
            id: 3,
            concept: selLanguage ? "Συνεχόμενες θέσεις μνήμης" : "Contiguous Memory Locations",
            definition: selLanguage
                ? "Τα στοιχεία αποθηκεύονται σε γειτονικές θέσεις, προσφέροντας γρήγορη και αποδοτική προσπέλαση."
                : "Elements are stored in adjacent memory locations, enabling fast and efficient access."
        },
        {
            id: 4,
            concept: selLanguage ? "Σταθερό μέγεθος" : "Fixed Size",
            definition: selLanguage
                ? "Το μέγεθος του πίνακα ορίζεται κατά τη δημιουργία του και δεν αλλάζει."
                : "The size of the array is defined at creation time and cannot change."
        },
        {
            id: 5,
            concept: selLanguage ? "Τυχαία πρόσβαση" : "Random Access",
            definition: selLanguage
                ? "Δυνατότητα γρήγορης ανάκτησης οποιουδήποτε στοιχείου μέσω του δείκτη."
                : "Allows fast retrieval of any element using its index."
        },
        {
            id: 6,
            concept: selLanguage ? "Αποδοτική διαχείριση μνήμης" : "Efficient Memory Usage",
            definition: selLanguage
                ? "Η αποθήκευση σε συνεχόμενες θέσεις βοηθά στη βελτίωση της ταχύτητας πρόσβασης λόγω καλύτερης φιλικότητας προς την cache της μνήμης."
                : "Storing data in contiguous memory improves access speed due to better cache friendliness."
        },
        {
            id: 7,
            concept: selLanguage ? "Αναποτελεσματική Χρήση Μνήμης" : "Inefficient Memory Usage",
            definition: selLanguage
                ? "Επειδή η συνολική μνήμη δεσμεύεται από την αρχή, υπάρχει ο κίνδυνος σπατάλης πόρων αν ο πίνακας είναι μεγαλύτερος από τον αριθμό των στοιχείων που τελικά χρειάζονται."
                : "Since memory is preallocated, there is a risk of wasted resources if the array is larger than needed."
        },
        {
            id: 8,
            concept: selLanguage ? "Περιορισμένη Ευελιξία" : "Limited Flexibility",
            definition: selLanguage
                ? "Οι πίνακες δεν είναι κατάλληλοι για επεξεργασία πιο πολύπλοκων δομών δεδομένων λόγω της απλοϊκής γραμμικής τους φύσης."
                : "Arrays are not ideal for handling more complex data structures due to their simple linear nature."
        },
        {
            id: 9,
            concept: selLanguage ? "Μόνο ένας Τύπος Δεδομένων" : "Single Data Type",
            definition: selLanguage
                ? "Τα στοιχεία του πίνακα πρέπει να είναι όλα του ίδιου τύπου, κάτι που περιορίζει την ευελιξία στην αποθήκευση ετερογενών δεδομένων."
                : "All elements must share the same data type, limiting flexibility for storing heterogeneous data."
        },
        {
            id: 10,
            concept: selLanguage ? "Λάθη Υπερχείλισης" : "Overflow Errors",
            definition: selLanguage
                ? "Αν γίνει προσπάθεια πρόσβασης σε θέση εκτός των ορίων του πίνακα, το πρόγραμμα μπορεί να εμφανίσει λάθη ή απρόβλεπτη συμπεριφορά."
                : "Accessing out-of-bounds array positions may cause errors or unpredictable behavior."
        }
    ];


    const [leftItems, setLeftItems] = useState([]);
    const [rightItems, setRightItems] = useState([]);

    useEffect(() => {
        initializeGame();
    }, []);

    const initializeGame = () => {

        const shuffledConcepts = [...gameData].sort(() => Math.random() - 0.5);
        const shuffledDefinitions = [...gameData].sort(() => Math.random() - 0.5);

        setLeftItems(shuffledConcepts.map(item => ({ ...item, type: 'concept' })));
        setRightItems(shuffledDefinitions.map(item => ({ ...item, type: 'definition' })));
        setMatchedPairs([]);
        setWrongMatches([]);
        setSelectedLeft(null);
        setSelectedRight(null);
        setLives(3);
        setScore(0);
        setShowGameOver(false);
        setShowGameWon(false);
        setGameState("playing");
        setMessage(selLanguage ? "Συνδέστε κάθε έννοια με τον σωστό ορισμό της!" : "Match each concept with its correct definition!");
    };

    const handleLeftClick = (item) => {
        if (matchedPairs.includes(item.id) || gameState !== "playing") return;
        setSelectedLeft(item);
        if (selectedRight) {
            checkMatch(item, selectedRight);
        }
    };

    const handleRightClick = (item) => {
        if (matchedPairs.includes(item.id) || gameState !== "playing") return;
        setSelectedRight(item);
        if (selectedLeft) {
            checkMatch(selectedLeft, item);
        }
    };

    const checkMatch = (leftItem, rightItem) => {
        if (leftItem.id === rightItem.id) {

            setMatchedPairs(prev => [...prev, leftItem.id]);
            setScore(prev => prev + 10);
            setMessage(selLanguage ? "Σωστό! Μπράβο!" : "Correct! Well done!");


            if (matchedPairs.length + 1 === gameData.length) {
                setGameState("won");
                setShowGameWon(true);
            }
        } else {

            const livesRemaining = lives - 1;
            setLives(livesRemaining);
            setWrongMatches(prev => [...prev, { left: leftItem.id, right: rightItem.id }]);
            setMessage(selLanguage ? "Λάθος συνδυασμός! Προσπαθήστε ξανά." : "Wrong match! Try again.");

            // Έλεγχος αν τελείωσαν οι ζωές
            if (livesRemaining === 0) {
                setGameState("lost");
                setShowGameOver(true);

            }

            // Καθαρισμός λάθους μετά από 1 δευτερόλεπτο
            setTimeout(() => {
                setWrongMatches(prev => prev.filter(match =>
                    !(match.left === leftItem.id && match.right === rightItem.id)
                ));
            }, 1000);
        }

        setSelectedLeft(null);
        setSelectedRight(null);

        // Καθαρισμός μηνύματος μετά από 2 δευτερόλεπτα
        setTimeout(() => {
            if (gameState === "playing") {
                setMessage("");
            }
        }, 2000);
    };

    const getItemStyle = (item, isLeft) => {
        const isMatched = matchedPairs.includes(item.id);
        const isSelected = isLeft ? selectedLeft?.id === item.id : selectedRight?.id === item.id;
        const isWrongMatch = wrongMatches.some(match =>
            isLeft ? match.left === item.id : match.right === item.id
        );

        return {
            padding: "12px 16px",
            margin: "6px 0",
            borderRadius: "12px",
            cursor: isMatched || gameState !== "playing" ? "default" : "pointer",
            fontWeight: "600",
            fontSize: "0.85rem",
            border: "2px solid",
            transition: "all 0.3s ease",
            background: isMatched
                ? "linear-gradient(45deg, #10b981, #059669)"
                : isWrongMatch
                    ? "linear-gradient(45deg, #ef4444, #dc2626)"
                    : isSelected
                        ? "linear-gradient(45deg, #3b82f6, #2563eb)"
                        : "linear-gradient(45deg, #f8fafc, #e2e8f0)",
            color: isMatched || isWrongMatch || isSelected ? "white" : "#334155",
            borderColor: isMatched
                ? "#059669"
                : isWrongMatch
                    ? "#dc2626"
                    : isSelected
                        ? "#2563eb"
                        : "#cbd5e1",
            boxShadow: isSelected || isMatched ? "0 8px 25px rgba(0,0,0,0.15)" : "0 2px 8px rgba(0,0,0,0.1)",
            transform: isSelected ? "translateY(-2px) scale(1.02)" : "none",
            textAlign: "center",
            lineHeight: "1.4"
        };
    };

    return (
        <div
            className='main-content oneArrayContainer'
            style={{
                background: darkMode ? "#1E293B" : "var(--customBuildButton)",
            }}
        >
            <GameOverModal
                isVisible={showGameOver}
                onPlayAgain={initializeGame}

            />


            <GameWonModal
                isVisible={showGameWon}
                onPlayAgain={initializeGame}

            />

            <div className="max-w-7xl mx-auto">
                {/* Lives Display */}
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginBottom: "5px" }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        justifyContent: "right",
                        gap: "12px"
                    }}>

                        <div style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center"
                        }}>
                            {[1, 2, 3].map((heartNum) => (
                                <div
                                    key={heartNum}
                                    style={{
                                        fontSize: "24px",
                                        filter: lives >= heartNum
                                            ? "drop-shadow(0 4px 8px rgba(220, 38, 38, 0.4))"
                                            : "grayscale(100%) opacity(0.3)",
                                        transform: lives >= heartNum ? "scale(1)" : "scale(0.8)",
                                        transition: "all 0.3s ease",
                                        animation: lives >= heartNum ? "heartbeat 2s ease-in-out infinite" : "none"
                                    }}
                                >
                                    ❤️
                                </div>
                            ))}
                        </div>
                    </div>

                    <style>{`
                        @keyframes heartbeat {
                            0%, 100% { transform: scale(1); }
                            50% { transform: scale(1.1); }
                        }
                    `}</style>
                </div>

                <br />

                {/* Instructions */}
                <div className="oneArrayPron">
                    {mission}
                </div>

                {/* Game Frame */}
                <div className="oneArrayFrame">
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "30px",
                        height: "100%"
                    }}>
                        {/* Left Column - Concepts */}
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%"
                        }}>
                            <h3 style={{
                                textAlign: "center",
                                marginBottom: "20px",
                                color: "#f0f0f0ff",
                                fontSize: "1.3em",
                                fontWeight: "700",
                                borderBottom: "3px solid #3b82f6",
                                paddingBottom: "10px"
                            }}>
                                {selLanguage ? "Έννοιες" : "Concepts"}
                            </h3>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px",
                                flex: 1,
                                overflowY: "auto"
                            }}>
                                {leftItems.map((item) => (
                                    <motion.div
                                        key={`left-${item.id}`}
                                        onClick={() => handleLeftClick(item)}
                                        style={getItemStyle(item, true)}
                                        whileHover={!matchedPairs.includes(item.id) && gameState === "playing" ?
                                            { scale: 1.02, y: -2 } : {}}
                                        whileTap={!matchedPairs.includes(item.id) && gameState === "playing" ?
                                            { scale: 0.98 } : {}}
                                    >
                                        {item.concept}
                                    </motion.div>
                                ))}
                            </div>
                        </div>

                        {/* Right Column - Definitions */}
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%"
                        }}>
                            <h3 style={{
                                textAlign: "center",
                                marginBottom: "20px",
                                color: "#f0f0f0ff",
                                fontSize: "1.3em",
                                fontWeight: "700",
                                borderBottom: "3px solid #3b82f6",
                                paddingBottom: "10px"
                            }}>
                                {selLanguage ? "Ορισμοί" : "Definitions"}
                            </h3>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px",
                                flex: 1,
                                overflowY: "auto"
                            }}>
                                {rightItems.map((item) => (
                                    <motion.div
                                        key={`right-${item.id}`}
                                        onClick={() => handleRightClick(item)}
                                        style={getItemStyle(item, false)}
                                        whileHover={!matchedPairs.includes(item.id) && gameState === "playing" ?
                                            { scale: 1.02, y: -2 } : {}}
                                        whileTap={!matchedPairs.includes(item.id) && gameState === "playing" ?
                                            { scale: 0.98 } : {}}
                                    >
                                        {item.definition}
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Intro1D;